import { render } from "./FTSMonthlyFilter.vue?vue&type=template&id=728f8a3c&scoped=true&ts=true"
import script from "./FTSMonthlyFilter.vue?vue&type=script&lang=ts"
export * from "./FTSMonthlyFilter.vue?vue&type=script&lang=ts"

import "./FTSMonthlyFilter.vue?vue&type=style&index=0&id=728f8a3c&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-728f8a3c"]])

export default __exports__